import { createSlice } from '@reduxjs/toolkit';

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuthenticated: false,
    userInformation: null,
  },
  reducers: {
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.userInformation = action.payload; // Store user information on login
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.userInformation = null; // Clear user information on logout
    },
  },
});

// Action creators
export const { loginSuccess, logout } = authSlice.actions;

// Selector to get authentication state
export const selectAuth = (state) => state.auth;

// Export the reducer
export default authSlice.reducer;